<div class="folder-wrapper background-white">
  <div class="loader">Loading...</div>
  <div>loading screen c</div>
</div>
